import { render, staticRenderFns } from "./UserMenuPanel.vue?vue&type=template&id=585986d3&"
import script from "./UserMenuPanel.vue?vue&type=script&lang=js&"
export * from "./UserMenuPanel.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuPanel.vue?vue&type=style&index=0&id=585986d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports